
import { defineComponent } from "vue";
import state from "@/store/state";
import EmojiWrapper from "@/components/EmojiWrapper.vue";
import Message from "@/components/Message.vue";

export default defineComponent({
  name: "Preview",
  components: { EmojiWrapper, Message },
  data() {
    return {
      state: state
    };
  },
  setup() {
    const currentRoute = window.location.href;
    const cardLink = currentRoute.replace(
      "/preview",
      "/view" + state.queryString
    );

    return { cardLink };
  }
});
